import {IProductDto} from './ProductDto';

export interface IProductsDto {
    products: IProductDto[] | null;
}

export class ProductsDto implements IProductsDto {
    public products: IProductDto[];
    constructor() {
        this.products = new Array<IProductDto>();
    }
}